// extracted by mini-css-extract-plugin
export default {"pageLayout":"h-z","mainContent":"i-z","columnLayout":"j-z","columnLayoutFill":"k-z","columnLayoutLast":"l-z"};